import PropTypes from 'prop-types';
import React from 'react';
import CSSSquare from './CSSSquare';
import cx from 'classnames';
import './Busy.css';
import {injectIntl, defineMessages} from 'react-intl';

const MESSAGES = defineMessages({
  loading: {
    defaultMessage: 'Loading',
    id: 'Busy__Label',
    description: 'Label for loading icon',
  },
});

class Busy extends React.Component {
  render() {
    const {
      isLoading, 
      indicator, 
      children,
      intl,
    } = this.props;

    return (
      <div className={cx('Busy', {'Busy--is-loading': isLoading})}>
        {children}
        {isLoading ? (
          <div className="Busy__LoadingOverlay">
            <div role="status" aria-live="polite" className="Busy__LoadingOverlayContent" tabIndex="-1" aria-label={intl.formatMessage(MESSAGES.loading)}>{indicator}</div>
          </div>
        ) : null}
      </div>
    );
  }
}

Busy.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  indicator: PropTypes.element.isRequired,
};

Busy.defaultProps = {
  isLoading: false,
  indicator: <CSSSquare />,
};

export default injectIntl(Busy);
